import React, {useState, useEffect} from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import AlertDialog from './AlertDialog';

import _ from 'lodash';

import { setTimedOut, heartbeatRequest, setTimedOutLoggedOut } from '../actions';

const TimeoutMonitor = () => {
	const dispatch = useDispatch();
	const user = useSelector(state => state.user, _.isEqual);
	const timedOutLoggedOut = useSelector(state => state.timedOutLoggedOut);
	const navigate = useNavigate();
	const sevenDays = 1000 * 60 * 60 * 24 * 7;
	
	const [appTimeout, setAppTimeout] = useState(sevenDays);
	const [manageTimeout, setManageTimeout] = useState(false);
	
	useEffect(() => {
		if(user.member_no > 0 && user.inactive_timeout > 0){
			setAppTimeout(1000 * 60 * user.inactive_timeout);
			setManageTimeout(true);
			reset();
		} else {
			setAppTimeout(sevenDays);
			setManageTimeout(false); 
			pause();
		} //eslint-disable-next-line
	}, [user])
	
	const handleOnIdle = (event) => {
		if(manageTimeout){
			console.log('Timed out at due to inactivity. Inactivity limit is: '+ user.inactive_timeout + ' minutes.');
			dispatch(setTimedOut(true));
			navigate('/logout');
		} 
	}
 
	const handleOnAction = (event) => {
		if(manageTimeout){
			reset();
			dispatch(heartbeatRequest());
		} 
	}
	
	const { reset, pause } = useIdleTimer({
		timeout: appTimeout,
		onIdle: handleOnIdle,
		// onActive: handleOnActive,
		onAction: handleOnAction,
		debounce: 500
	});

	return timedOutLoggedOut ? 
		<AlertDialog 
			title='Logged Out'
			message='You have been logged out of U-MAS for Members due to inactivity.'
			handleClose={() => dispatch(setTimedOutLoggedOut(false))}
		/> : 
		null;
}

export default TimeoutMonitor